module.exports = __webpack_public_path__ + "static/ctrl.93cdb79261b2b9d579ab03605b54af0f.svg";